/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RestoreHistoryDto
 */
export interface RestoreHistoryDto {
    /**
     * 復元スコープ
     * - all: 全ての情報を復元（デフォルト）
     * - data: データのみを復元
     * - state: ワークフロー状態のみを復元
     * @type {object}
     * @memberof RestoreHistoryDto
     */
    scope?: object;
}

/**
 * Check if a given object implements the RestoreHistoryDto interface.
 */
export function instanceOfRestoreHistoryDto(value: object): value is RestoreHistoryDto {
    return true;
}

export function RestoreHistoryDtoFromJSON(json: any): RestoreHistoryDto {
    return RestoreHistoryDtoFromJSONTyped(json, false);
}

export function RestoreHistoryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RestoreHistoryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'scope': json['scope'] == null ? undefined : json['scope'],
    };
}

export function RestoreHistoryDtoToJSON(json: any): RestoreHistoryDto {
    return RestoreHistoryDtoToJSONTyped(json, false);
}

export function RestoreHistoryDtoToJSONTyped(value?: RestoreHistoryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'scope': value['scope'],
    };
}

